var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.76 3.10146L12.931 0.126521C12.131 -0.107849 11.2862 -0.0141011 10.5529 0.386933C9.82168 0.789008 9.2894 1.45045 9.05816 2.24315L8.48004 4.16811H3.12494C1.40206 4.16811 0 5.57017 0 7.29305V25H16.6663V22.8698L19.8944 24.0688L24.8745 6.97222C25.3558 5.31809 24.4027 3.57958 22.76 3.10146ZM14.5831 22.9167H2.08329V7.29201C2.08329 6.71806 2.54995 6.25036 3.12494 6.25036H13.5414C14.1164 6.25036 14.5831 6.71806 14.5831 7.29201V22.9167ZM22.8746 6.38994L18.5205 21.3355L16.6663 20.6459V7.29201C16.6663 5.56912 15.2643 4.16707 13.5414 4.16707H10.656L11.0571 2.83376C11.1352 2.5671 11.3123 2.34731 11.556 2.21294C11.8008 2.07857 12.0821 2.04836 12.3383 2.12336L22.1673 5.0983C22.7183 5.25871 23.0371 5.83891 22.8766 6.38994H22.8746Z",
    fill: "#0464B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaIcon);
export default __webpack_public_path__ + "static/media/VisaIcon.15137a3ea1948fd61968c440f88ef080.svg";
export { ForwardRef as ReactComponent };